import $ from "jquery";
import { TweenMax, TimelineMax } from "gsap";
import ScrollMagic from "scrollmagic";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

var controller = new ScrollMagic.Controller({
	globalSceneOptions: {
		offset: -1
	}
});

$('.parallax').each(function() {

	var _this = this;

	var translateYIn  = $(this).attr('data-translateY-in'),
		translateYOut = $(this).attr('data-translateY-out'),
		translateXIn  = $(this).attr('data-translateX-in'),
		translateXOut = $(this).attr('data-translateX-out'),
		opacityIn = $(this).attr('data-opacity-in'),
		opacityOut = $(this).attr('data-opacity-out');

	if (typeof translateYIn  === 'undefined') translateYIn = 0;
	if (typeof translateYOut === 'undefined') translateYOut = 0;
	if (typeof translateXIn  === 'undefined') translateXIn = 0;
	if (typeof translateXOut === 'undefined') translateXOut = 0;
	if (typeof opacityIn  === 'undefined') opacityIn = 1;
	if (typeof opacityOut === 'undefined') opacityOut = 1;

	var scene1 = new ScrollMagic.Scene({
		triggerElement: _this,
		triggerHook: 0,
		duration: function() {return $(_this).innerHeight() > ($(window).height() / 3) ? $(_this).innerHeight() : "35%"}
	})
		.setTween(TweenMax.fromTo(_this.children, 1,
			{translateY: 0, translateX: 0, opacity: 1},
			{ease: 'none', translateY: translateYOut, translateX: translateXOut, opacity: opacityOut}
		))
		.addTo(controller);

	var scene2 = new ScrollMagic.Scene({
		triggerElement: _this,
		triggerHook: 1,
		duration: function() {return $(_this).innerHeight() > ($(window).height() / 3) ? $(_this).innerHeight() : "35%"}
	})
		.setTween(TweenMax.fromTo(_this.children, 1,
			{translateY: translateYIn, translateX: translateXIn, opacity: opacityIn},
			{ease: 'none', translateY: 0, translateX: 0, opacity: 1}
		))
		.addTo(controller);

	// responsive
	if ($(_this).outerHeight() > $(window).height()) {
		scene1.enabled(false);
		scene2.enabled(false);
		$(_this.children).css('transform','');
	}

	$(window).on('resize', function() {
		window.requestAnimationFrame(function() {
			if ($(_this).outerHeight() > $(window).height()) {
				scene1.enabled(false);
				scene2.enabled(false);
				$(_this.children).css('transform','');
			} else {
				scene1.enabled(true);
				scene2.enabled(true);
			}
		});
	});

});

if ($('.nav--main').length && $('[data-fixnav]').length) {
	var scene = new ScrollMagic.Scene({
		triggerElement: '[data-fixnav]',
		triggerHook: 0
	})
		.setClassToggle(".nav--main", "nav--fixed")
		.addTo(controller);
}

if ($('.button-fixedwrapper').length && $('[data-fixnav]').length) {
	var scene = new ScrollMagic.Scene({
		triggerElement: '[data-fixnav]',
		triggerHook: 0
	})
		.setClassToggle(".button-fixedwrapper", "button-fixedwrapper--fixed")
		.addTo(controller);
}
